export default "__VITE_ASSET__bmX0daLH__"